import { useEffect, useState } from "react";

import { fetchSlideshow } from "../api";
import "./Home.css";

function Home() {
  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    const SLIDESHOW_ID = !isMobile
      ? process.env.REACT_APP_BACKGROUND_SLIDESHOW_ID
      : process.env.REACT_APP_BACKGROUND_SLIDESHOW_MOBILE_ID;
    fetchSlideshow(SLIDESHOW_ID)
      .then((data) => {
        setImages(data.images || []);
      })
      .catch((err) => console.error("Failed to fetch slideshow:", err));
  }, []);

  useEffect(() => {
    if (!images.length) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [images]);

  if (!images.length) return <div>Loading slideshow…</div>;

  const currentImage = images[currentIndex];

  return (
    <div className="slideshow-container">
      <img
        src={currentImage?.url}
        alt={currentImage?.alt || "slide"}
        className="slideshow-image"
      />

      {/* Slider Balls */}
      <div className="slider-dots">
        {images.map((_, idx) => (
          <div
            key={idx}
            className={`dot ${idx === currentIndex ? "active" : ""}`}
            onClick={() => setCurrentIndex(idx)}
          />
        ))}
      </div>
    </div>
  );
}

export default Home;
